import React from 'react';
import Sidebar from '@/components/Sidebar';
import IncompleteProfileBanner from '@/components/IncompleteProfileBanner';

export default function DashboardLayout({ children }) {
  return (
    <div className="flex h-screen overflow-hidden bg-[#09090b]" data-testid="dashboard-layout">
      <Sidebar />
      <main className="flex-1 overflow-y-auto flex flex-col">
        <IncompleteProfileBanner />
        <div className="p-6 flex-1">
          {children}
        </div>
      </main>
    </div>
  );
}
